var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReplase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3E6FDF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.38 20.25a2.63 2.63 0 100-5.25 2.63 2.63 0 000 5.25zM18.38 15v-3.76a4.5 4.5 0 00-1.32-3.18L13.5 4.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3E6FDF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 8.25V4.5h3.75M5.63 9a2.62 2.62 0 100-5.25 2.62 2.62 0 000 5.25zM5.63 9v3.76c0 1.2.47 2.34 1.31 3.18l3.56 3.56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3E6FDF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 15.75v3.75H6.75"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplase);
export default __webpack_public_path__ + "static/media/replase.b1876610.svg";
export { ForwardRef as ReactComponent };